export default __webpack_public_path__ + "static/media/eight_of_wands.c245a051.png";